import { useNavigate } from "react-router-dom";

interface BacktestComingSoonModalProps {
  open: boolean;
  onClose: () => void;
}

/** 客户点击回测入口时使用的统一提示，不发起回测请求。 */
export default function BacktestComingSoonModal({ open, onClose }: BacktestComingSoonModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="backtest-coming-soon-title"
        className="bg-white w-full max-w-xs rounded-2xl p-6 shadow-xl text-center"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center mx-auto mb-4">
          <i className="ri-time-line text-white text-2xl" />
        </div>
        <h3 id="backtest-coming-soon-title" className="text-base font-bold text-foreground-950 mb-1">
          该功能即将开通
        </h3>
        <p className="text-xs text-foreground-400 mb-5 leading-relaxed">
          回测功能正在升级完善，敬请期待。
        </p>
        <button
          onClick={onClose}
          className="w-full py-2.5 rounded-xl text-sm font-semibold bg-gradient-to-r from-primary-500 to-accent-500 text-white cursor-pointer hover:opacity-90 transition-all shadow-sm"
        >
          我知道了
        </button>
      </div>
    </div>
  );
}

/** 直接访问旧回测网址时同样拦截，避免绕过卡片按钮。 */
export function BacktestComingSoonPage() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm rounded-2xl bg-white border border-background-200/60 p-8 text-center shadow-sm">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center mx-auto mb-5">
          <i className="ri-time-line text-white text-3xl" />
        </div>
        <h1 className="text-lg font-bold text-foreground-950 mb-2">该功能即将开通</h1>
        <p className="text-sm text-foreground-400 mb-6">回测功能正在升级完善，敬请期待。</p>
        <button
          onClick={() => navigate("/ai-strategy", { replace: true })}
          className="w-full py-2.5 rounded-xl text-sm font-semibold bg-primary-500 text-white cursor-pointer hover:opacity-90 transition-opacity"
        >
          返回策略列表
        </button>
      </div>
    </div>
  );
}
